import { NavLink } from 'react-router-dom';
import styled from 'styled-components';

import { flexGap } from '@/shared/lib/helpers/flex-gag-polyfill.helper';
import { StyledCollapsed } from '@/widgets/sidebar/ui/sidebar/sidebar.types';

export const Link = styled(NavLink)<StyledCollapsed>`
	display: flex;
	justify-content: ${({ collapsed }) => collapsed && 'center'};
	${flexGap('12px')};
	padding: 8px;
	border-radius: 6px;
	transition: 0.2s;

	& > p {
		color: ${({ theme: { link } }) => link.color};
	}

	& > svg {
		fill: ${({ theme: { link } }) => link.color};
	}

	&:visited {
		background: transparent;

		& > p {
			color: ${({ theme: { link } }) => link.color};
		}

		& > svg {
			fill: ${({ theme: { link } }) => link.color};
		}
	}
	&:hover,
	&.active {
		background: ${({ theme: { link } }) => link.active.background};

		& > p {
			color: ${({ theme: { link } }) => link.active.colors.primary};
		}

		& > svg {
			fill: ${({ theme: { link } }) => link.active.colors.primary};
		}
	}

	&:hover {
		background: ${({ theme: { link } }) => link.active.hover};
	}
`;
